import React from 'react';
interface TabProps { 
    class?: string;
    id?: string;
    label?: string;
    tabIndex?: number;
    onFocus?: () => void;
    children?: React.ReactElement[] | React.ReactElement | any;
    icon?: string
    disabled?: boolean
}

 function Tab(props: TabProps) {
    return (        
        <div className={props.class} id={props.id} role="tabpanel" tabIndex={props.tabIndex} onFocus={props.onFocus}>
            {props.children }
        </div>            
    );
}

Tab.defaultProps = {
    class: "",
    id: "",
    label: "",
    tabIndex: 0,
    onFocus: () => {}, 
}

export default Tab
